<div class="question-card" [@fadeIn]>
  <!-- Question text -->
  <div class="question-text" [class.rtl]="currLang === 'ar'">
    {{getQuestionText()}}
  </div>

  <!-- Options grid -->
  <div class="options-grid">
    <button
      *ngFor="let option of question.options; let i = index"
      class="option-btn"
      [class.selected]="selectedOption === option.id"
      [style.--option-color]="optionColors[i]"
      (click)="selectOption(option.id)">
      <span class="option-label" [style.background]="optionColors[i]">{{getOptionLabel(option.id)}}</span>
      <span class="option-text" [class.rtl]="currLang === 'ar'">{{getOptionText(option)}}</span>
    </button>
  </div>
</div>
